import {
    GeneralActionTypes,
    GeneralState,
    RESET_REQUEST_ERROR,
    SET_IS_LOADING_STATUS,
    SET_REQUEST_ERROR,
    SET_STATUS
} from '../../types/general';

export const initialState: GeneralState = {
    requestError: null,
    isLoadingStatus: false,
    status: null
};

export const generalReducer = (state = initialState, action: GeneralActionTypes): GeneralState => {
    switch (action.type) {
        case SET_IS_LOADING_STATUS:
            return { ...state, isLoadingStatus: action.isLoadingStatus }
        case SET_STATUS:
            return { ...state, status: action.status }
        case RESET_REQUEST_ERROR:
            return { ...state, requestError: null }
        case SET_REQUEST_ERROR:
            return { ...state, requestError: action.error }
        default:
            return state;
    }
};
